export default __webpack_public_path__ + "static/blob-54-dbe9b88c75e55cd298925a8a19923b19.svg";